/**
 * @file Custom Prints related fragments.
 */

import gql from 'graphql-tag';

import { AccountAddressFields } from './account';

export const PhotoUrlTypeFields = gql`
  fragment PhotoUrlTypeFields on PhotoURLType {
    url
    width
    height
    size_code
  }
`;

export const AlbumCustomPrintDetails = gql`
  fragment AlbumCustomPrintDetails on AlbumCustomPrint {
    id
    photos_no
    custom_print {
      id
      name
      type
      preview_image {
        id
        url
      }
      photos_no
      custom_print_caption_enabled
    }
    price {
      value
      currency
    }
    discount_price {
      value
      currency
    }
    shipping_price {
      value
      currency
    }
    album {
      id
    }
    shipping_enabled
    shipping_required
  }
`;

export const PurchasedCustomPrintFullDetails = gql`
  fragment PurchasedCustomPrintFullDetails on PurchasedCustomPrint {
    id
    photos_no
    custom_print_caption_enabled
    custom_print_caption
    order_status
    shipping_enabled
    shipping_purchased
    shipping_required
    name
    custom_print_type
    delivery_type
    preview_image {
      id
      url
    }
    shipping_price {
      value
      currency
    }
    custom_print {
      id
      name
      type
      preview_image {
        id
        url
      }
    }
    photos {
      records {
        id
        position
        photo {
          id
          thumbnail_urls {
            ...PhotoUrlTypeFields
          }
        }
      }
    }
    selected_identity {
      id
      matched_photos_extended(slice: { limit: 9999 }) {
        total
      }
    }
    identity {
      id
      name
      last_name
      current_photo {
        id
        thumbnail_urls {
          ...PhotoUrlTypeFields
        }
      }
    }
    account_address {
      ...AccountAddressFields
    }
    account {
      id
      addresses {
        ...AccountAddressFields
      }
    }
  }
  ${PhotoUrlTypeFields}
  ${AccountAddressFields}
`;

export const PurchasedCustomPrintProCandidatePhotosDetails = gql`
  fragment PurchasedCustomPrintProCandidatePhotosDetails on PurchasedCustomPrint {
    id
    selected_identity {
      id
      matched_photos_extended(
        slice: { limit: $limit, offset: $matchesOffset }
      ) {
        total
        records {
          id
          photo {
            id
            thumbnail_urls(ignore_watermark: true) {
              ...PhotoUrlTypeFields
            }
          }
        }
      }
      album_membership {
        id
        favorited_photos(slice: { limit: $limit, offset: $favoritesOffset }) {
          total
          records {
            id
            thumbnail_urls(ignore_watermark: true) {
              ...PhotoUrlTypeFields
            }
          }
        }
      }
    }
    album {
      id
      photos(slice: { limit: $limit, offset: $albumPhotosOffset }) {
        total
        records {
          id
          thumbnail_urls(ignore_watermark: true) {
            ...PhotoUrlTypeFields
          }
        }
      }
    }
  }
  ${PhotoUrlTypeFields}
`;

export const AlbumCustomPrintForPurchaseDetails = gql`
  fragment AlbumCustomPrintForPurchaseDetails on AlbumCustomPrint {
    id
    photos_no
    shipping_enabled
    custom_print {
      id
      name
      type
      subtype
      preview_image {
        id
        url
      }
      card {
        id
        card_side_groups {
          records {
            id
            side
            card_sides {
              records {
                id
                card_template {
                  id
                  print_product {
                    id
                    print_size {
                      id
                      name
                    }
                    print_partner {
                      id
                      name
                    }
                    sizes(slice: { limit: 999 }) {
                      records {
                        id
                        print_size {
                          id
                          name
                        }
                      }
                    }
                  }
                  print_size {
                    id
                    name
                  }
                }
              }
            }
          }
        }
      }
      account {
        ...VendorDetails
      }
    }
    price {
      value
      currency
    }
    discount_price {
      value
      currency
    }
    shipping_price {
      value
      currency
    }
    album {
      id
    }
    shipping_enabled
    shipping_required
  }
`;
